import React, { useState } from "react";
import { useSelector } from "react-redux";
import ImageViewer from "../ContentsViewer/ImageViewer";
import classes from "./ImageEditor.module.css";
import ImageUploadPopup from "./UploadPopup/ImageUploadPopup/ImageUploadPopup";


const ImageEditor = ({ data, setContentData }) => {
    const [showImageUploadPopup, setShowImageUploadPopup] = useState();
    
    const { texts } = useSelector(state => state.translate);

    const uplaodBG = (values) => {
        setContentData({ ...data, ...values });
        setShowImageUploadPopup(false)
    }

    return <div className={classes.ImageEditor}>
        <div className={classes.Header}>
            <button className={classes.Btn} onClick={() => setShowImageUploadPopup(true)} >{texts.bgImage}</button>
            {showImageUploadPopup && <ImageUploadPopup initValues={data} addCallback={uplaodBG} close={() => setShowImageUploadPopup(false)} />}
        </div>
        {data && data.url && <div className={classes.ImageViewerWrap}>
            <ImageViewer data={data}></ImageViewer>
        </div>}
    </div>
}
export default ImageEditor;